import React from 'react'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'
import { Grid, Typography } from '@mui/material'

import Column from './Structure/Column'
import { Alert } from '@carsys/ui'
import { useTranslation } from 'react-i18next'

const Structure: React.FC = () => {
  const { t } = useTranslation()
  const categories = useSelector((state: IRootReducerState) => state.productGroup.tree?.Categories)

  if (!categories || !categories.length) return <Alert color='muted'>{t('productgroup.no_mainGroups')}</Alert>

  return (
    <>
      <Typography variant='h6' sx={{ mb: 2 }}>
        {t('productgroup.tree_maingroup_title')}
      </Typography>
      <Grid container spacing={3}>
        {categories.map(c => (
          <Grid key={c.UUID} item data-testid='column'>
            <Column category={c} />
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default Structure
